import { EventImageMediaType } from '../types/media-type';
export const getFormattedEventImageAltText = (event, mediaType, accessibilityText, i18n) => {
    const template = getAltTextFormatForEventImageMediaType(mediaType, accessibilityText);
    return i18n.template(template, {
        eventName: i18n.translatable(event.name)
    });
};
export const getAltTextFormatForEventImageMediaType = (mediaType, accessibilityText) => {
    const { eventPosterAltTextFormat, eventGalleryImageAltTextFormat } = accessibilityText;
    switch (mediaType) {
        case EventImageMediaType.Poster:
            return eventPosterAltTextFormat;
        case EventImageMediaType.Gallery:
            return eventGalleryImageAltTextFormat;
        default:
            throw new Error(`Cannot get alt text format for unknown FilmThumbnailMediaType: '${mediaType}'.`);
    }
};
